import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MonitorSegment } from 'src/app/models/monitor-segments.model';
import { MonitorTrend } from 'src/app/models/monitor-trend.model';
import {
  MonitorData,
  MonitorDataPeriods,
} from 'src/app/services/request-models/get-monitor-data.model';

import { MonitorAdvice } from './feature';

export const MonitorActions = createActionGroup({
  source: 'Monitor',
  events: {
    'Set Active Monitor Segment': props<{ segment: MonitorSegment }>(),
    'Set Monitor Segment Advice': props<{
      segment: MonitorSegment;
      advice: MonitorAdvice;
    }>(),
    'Set Monitor Segment Periods': props<{
      segment: MonitorSegment;
      periods: MonitorDataPeriods;
    }>(),
    'Set Monitor Segment Score And Trend': props<{
      segment: MonitorSegment;
      score?: number;
      trend?: MonitorTrend;
    }>(),
    'Load All Monitor Data': emptyProps(),
    'Load Monitor Segment Data': props<{ segment: MonitorSegment }>(),
    'Load Monitor Segment Data Failure': props<{ message?: string }>(),
    'Monitor Segment Data Loaded': props<{
      segment: MonitorSegment;
      data: MonitorData;
    }>(),
  },
});

export default MonitorActions;
